// removed by extract-text-webpack-plugin
module.exports = {"bottombar":"_3ZBTCv80Ghea4rHGYODRhz","command":"_1yj2PKY997VT4J4zqAsR8J"};


//////////////////
// WEBPACK FOOTER
// ./~/wix-style-react/dist/es/src/SideBar/BottomBar.scss
// module id = ./node_modules/wix-style-react/dist/es/src/SideBar/BottomBar.scss
// module chunks = 0